import type { PlatformComponentProps } from "@b2bportal/core-types";
import { Breadcrumbs } from "@b2bportal/core-ui";
import { useCarBreadcrumbs } from "~core-cars/features";
import type { CarSteps } from "~core-cars/utilities/flow/CarNavigationFlowProvider";

export type CarBreadcrumbsComponentProps = PlatformComponentProps & {
  currentStep: CarSteps;
};

export const CarBreadcrumbs = ({
  currentStep,
  className,
}: CarBreadcrumbsComponentProps) => {
  const { steps } = useCarBreadcrumbs({ currentStep });

  return <Breadcrumbs steps={steps} className={className} />;
};
